'use client';

import IllustrationMotion from '@/features/empty-state/IllustrationMotion';
import { motion } from 'framer-motion';
import { Button } from 'react-bootstrap';
import { readCartMessage } from './cartMessages';

export default function CartEmptyState({ messages }) {
  return (
    <div className="cart-empty-state w-100">
      <div className="empty-state">
        <div className="empty-state__left flex-fill d-flex flex-column align-items-center">
          <div className="empty-state__img">
            <IllustrationMotion
              src="/images/emptyCart.png"
              alt={readCartMessage(
                messages,
                'cartScreen',
                'cartEmpty',
                'Your Cart is Empty',
              )}
              maxHeight={400}
              noBorder
            />
          </div>
        </div>
        <div className="empty-state__right d-flex flex-column align-items-center justify-content-start flex-fill">
          <h2 className="fw-normal fs-5 mb-1">
            {readCartMessage(
              messages,
              'cartScreen',
              'cartEmpty',
              'Your Cart is Empty',
            )}
          </h2>
          <p className="fs-6 opacity-75 mb-3">
            {readCartMessage(
              messages,
              'cartScreen',
              'emptyCartHelper',
              'Looks like you have not added anything yet.',
            )}
          </p>
          <Button
            as={motion.button}
            initial={{ opacity: 0, y: 3 }}
            animate={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.02 }}
            variant="transparent"
            className="app-button--primary app-button "
            onClick={() => window.location.assign('/shop#latest-products')}
            aria-label={readCartMessage(
              messages,
              'cartScreen',
              'startShoppingAria',
              'Start shopping and discover our products',
            )}
          >
            {readCartMessage(
              messages,
              'cartScreen',
              'startShopping',
              'Start Shopping',
            )}{' '}
            👉
          </Button>
        </div>
      </div>
    </div>
  );
}
